import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ServicesHeroImg from "../assets/hero/static.JPG";
import Footer from "../components/Footer";
import ServicesList from "../components/ServicesList";
import ServicesIntroduction from "../components/ServicesIntroduction";

function Services() {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = "Serviços | Cubic";

    // Quando se chega com âncora (ex. /servicos#subestacoes, a partir dos
    // cartões da Home), salta para a secção em vez de ir ao topo.
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = hash.replace("#", "");

    // Num carregamento a frio, as imagens ainda não ocuparam o seu espaço e a
    // posição da secção muda debaixo dos pés. Tenta-se algumas vezes até a
    // altura da página estabilizar, em vez de saltar uma só vez logo à entrada.
    let attempts = 0;
    let lastHeight = -1;

    const jump = () => {
      const target = document.getElementById(id);
      if (!target) return;

      const height = document.body.scrollHeight;
      target.scrollIntoView({ behavior: "auto", block: "start" });

      attempts += 1;
      if (height !== lastHeight && attempts < 10) {
        lastHeight = height;
        timer = setTimeout(jump, 150);
      }
    };

    let timer = setTimeout(jump, 50);

    // Correção final: quando as imagens terminam de carregar a página cresce,
    // e sem isto a secção fica uns 100 px acima do sítio certo.
    const onLoad = () => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: "auto", block: "start" });
    };
    window.addEventListener("load", onLoad);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("load", onLoad);
    };
  }, [hash]);

  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg={ServicesHeroImg}
        title="Serviços"
        titleClass="page-title"
        btnClass="hide"
      />
      <ServicesIntroduction />
      <ServicesList />
      <Footer />
    </>
  );
}

export default Services;
